export default "__VITE_ASSET__$dX5ivxB__"